import React from 'react';

import { ErrorPage, DeviceContext } from '@tecma/ds';
import { logger } from '@tecma/logs-fe';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';

import { Providers } from 'components/Providers/Providers';

import App from './App';
import reportWebVitals from './reportWebVitals';

import './index.scss';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <ErrorBoundary
      FallbackComponent={() => <ErrorPage />}
      onError={(error) => {
        logger.error(error);
      }}
    >
      <Providers>
        <DeviceContext>
          <App />
        </DeviceContext>
      </Providers>
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
